import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import axios from "axios";

import App from "./App";

const store = require("store");

axios.interceptors.request.use((config) => {
  const imp = store.get("impersonate_username");
  if (imp) {
    config.headers = config.headers || {};
    config.headers["X-Impersonate-User"] = imp;
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
